// extracted by mini-css-extract-plugin
export default {"cls1":"mKauyQE1PaSj11wo056M","cls2":"bB2yt7OMRBgWETpCwHBg mKauyQE1PaSj11wo056M","isTabletDown":"tkwYPCHqMJ7fp4ohPkg7"};